<div *ngIf="verificationArr.length>0">

<!-- Manual Invoking : Button -->
<button nz-button nzType="primary" (click)="makeVisionAPICall()" *ngIf="1||mode=='manual'">Verify using OCR</button>

<!-- Verification Result -->
<div class="m-t-10">

  <h3 class="col-orange d-b f-s-1-3r" *ngIf="isProcessing">
    <i nz-icon nzType="loading" nzTheme="outline"></i> Processing
  </h3>
  <!-- Result text -->
  <div>

    <h3 *ngIf="verificationResultText.toLowerCase()=='passed'" class="col-green d-b f-s-1-3r">
      <i nz-icon nzType="check" nzTheme="outline"></i> Passed
    </h3>
    <h3 *ngIf="verificationResultText.toLowerCase()=='partially passed'" class="col-orange d-b f-s-1-3r">
      <i nz-icon nzType="issues-close" nzTheme="outline"></i> Partially Passed
    </h3>
    <h3 *ngIf="verificationResultText.toLowerCase()=='failed'" class="col-red d-b f-s-1-3r">
      <i nz-icon nzType="close" nzTheme="outline"></i> Failed
    </h3>

    <nz-table nzSize="small" [nzData]="[0,1,0]" [nzShowPagination]="false" class="p-b-20 d-i-b" style="max-width: 400px;">
      <thead>
      <tr>
        <th>Item</th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let d of verificationArr">
        <td>{{d.key}} ({{d.value}})</td>
        <td>
          <span *ngIf="d.status.toLowerCase()=='pending'" class="col-grey-dark">{{d.status}}</span>
          <span *ngIf="d.status.toLowerCase()=='passed'" class="col-green">{{d.status}}</span>
          <span *ngIf="d.status.toLowerCase()=='failed'" class="col-red">{{d.status}}</span>
          <span *ngIf="d.status.toLowerCase()=='processing'" class="col-orange">{{d.status}} ...</span>
        </td>
      </tr>
      </tbody>
    </nz-table>

  </div>

</div>


</div>
